module.exports = __webpack_public_path__ + "assets/img/nodata.f165797c.png";